import { Size } from 'shared/size'

export const SIZE_ICON_CSS: Record<Size, string> = {
  lg: 'w-[24px] h-[24px]',
  md: 'w-[20px] h-[20px]',
  sm: 'w-[16px] h-[16px]',
  xs: 'w-[14px] h-[14px]',
  xxs: 'w-[12px] h-[12px]',
}
